import * as apiFactory from "./ApiFactory";
import { Api } from "./Api";

import type { BrandLens } from "@/models/BrandLens";

export async function getAll(clientName: string, brand: string): Promise<BrandLens[]> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<BrandLens[]>(["api/brandLens", clientName, brand]);
}
